/**
 *    @author:
 *    @since:
 *
 */

 import { ViewportScroller } from '@angular/common';
 import { Util } from 'src/refresh/service/Util';
 import { IValidator } from '../_common/component/IValidator';
 import { OrderOfBC } from '../_common/data/input-data';
 import { BirthCertificateComponent} from './birth_certificate.component';
 
 export class BirthCertificateValidation extends IValidator {
 
        constructor(private component: BirthCertificateComponent, private menuID:number) {
               super();
               this.orderOfBC.backup( this.component.data.orderOfBC);
               this.viewportScroller = this.component.viewportScroller;
        }
 
        private orderOfBC:OrderOfBC = new OrderOfBC();
        private viewportScroller:ViewportScroller;
        private success: boolean;
 
        public validate(): boolean {
 
           this.success = true;
 
           if(this.component.isChildDeceased() && !this.component.isAddedToOrderForDeceasedChild() ){
                   this.focus('childDeceased','chkbox_childDeceasedBCcheckbox').error_invalidSubmit = 'birth_certificate.error_invalidSubmit_CBC';
          }
           else if(!this.component.isAddedToOrder()){
             this.component.orderOfBC.isReviewOtherTypeBC = "";
                   this.focus('orderOfBC','chkbox_orderOfBCcheckbox').error_invalidSubmit = 'birth_certificate.error_invalidSubmit';
           }else{
                if(this.component.data.eligibility.listedParentCount > 1 && this.component.data.eligibility.certifyingParentCount != 1 &&
                          this.component.orderOfBC.applicantIndex == -1 && this.component.data.eligibility.isCustodyOtherThanParent != 'Y'){
                   this.focus('twoOrMoreCertifying','radio_twoOrMoreCertifyingRadio_0').error_whichParent = 'birth_certificate.error_whichParent';
                }
                else if(this.component.data.eligibility.certifyingParentCount == 1 && 
                          this.component.orderOfBC.applicantIndex == -1){
                   this.focus('birtCertificateSingleParent','chkbox_birtCertificateSingleParentCheckbox').error_whichParent = 'birth_certificate.error_whoIsBcApplicant';
                }
                else if(this.component.data.eligibility.isCustodyOtherThanParent == 'Y' && 
                          this.component.orderOfBC.applicantIndex == -1){
                   this.focus('isCustody','chkbox_isCustodyCheckbox').error_whichParent = 'birth_certificate.error_whoIsBcApplicant';
                }
                else if(this.component.data.eligibility.isCustodyOtherThanParent == 'Y' && 
                         Util.hasSpecialCharacter(this.component.orderOfBC.organizationForOther)){
                   this.focus('organization','input_organizationInput').error_invalidOrgName = 'birth_certificate.error_invalidOrgName';
                }   
                else if(this.component.orderOfBC.applicantIndex > -1
                     && !(this.component.orderOfBC.chk_BCConsent == 'Y')){
                   this.focus('consent','chkbox_birthCertificateCheckbox').error_invalidConsent = 'birth_certificate.error_invalidConsent';
                }
 
           }
 
           return this.success;
      }
 
      private focus(tagId:string,ctrlId:string) : BirthCertificateComponent {
       if ( this.success ) {
            this.viewportScroller.scrollToAnchor(tagId);
            let ctrl = document.getElementById(ctrlId);
            if ( ctrl ) ctrl.focus();
       }
            
       this.success = false;
       return this.component;
       }
 
      public IdOfChanged():number { 
             let inputOrderBC:OrderOfBC = this.component.data.orderOfBC;
             if ( this.orderOfBC.hasBCWithParentInfo != inputOrderBC.hasBCWithParentInfo 
               || this.orderOfBC.isReviewOtherTypeBC != inputOrderBC.isReviewOtherTypeBC 
               || this.orderOfBC.hasBirthCertificate != inputOrderBC.hasBirthCertificate 
               || this.orderOfBC.applicantIndex != inputOrderBC.applicantIndex 
               || this.orderOfBC.organizationForOther != inputOrderBC.organizationForOther 
               || this.orderOfBC.chk_BCConsent != inputOrderBC.chk_BCConsent 
                ) return this.menuID;
             return 0;
      }
 }
 
 